import './setPublicPath'
import mod from '~entry'
export default mod
export * from '~entry'
